import Vue from "vue"
import Router from "vue-router"

const baseRoutes = [
	{
		path: "/",
		name: "Home",
		component: () => import("@/views/home/Home")
	},
	{
		path: "/e/:code",
		name: "EventDetail",
		component: () => import("@/views/events/EventDetail")
	},
	{
		path: "/e/:code/purchase/:orderId/:transactionId?/:transactionStatus?",
		name: "TicketPurchase",
		component: () => import("@/views/purchase/TicketPurchase")
	},
	{
		path: "/m/:code/purchase/:transactionId?/:transactionStatus?",
		name: "MembershipPurchase",
		component: () => import("@/views/purchase/MembershipPurchase")
	},
	{
		path: "/purchase/result/:transactionId/:transactionStatus?",
		name: "PurchaseResult",
		component: () => import("@/views/purchase/PurchaseResult")
	}
]

const loadedRoutes = loadRoutes()

let routes = baseRoutes.concat(...loadedRoutes, {
	path: "*",
	redirect: "/"
})

Vue.use(Router)

let router = new Router({
	mode: "history",
	routes
})

router.beforeEach((to, from, next) => {
	var loggedIn = localStorage.getItem("logged")
	loggedIn = JSON.parse(loggedIn)
	// console.log('router.beforeEach loggedIn', loggedIn);
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		if (loggedIn) {
			//console.log('router  estoy logueado')
			window.scrollTo(0, 0)
			next()
			return
		}
		//console.log('router  go to login')
		window.scrollTo(0, 0)
		next("/logout")
		// next()
	} else {
		window.scrollTo(0, 0)
		next()
	}
})
function loadRoutes() {
	const context = require.context("@/views/", true, /\.router.js$/)
	return context
		.keys()
		.map(context) // import module
		.map((m) => m.default) // get `default` export from each resolved module
}
export default router
